import { Component, OnInit, OnDestroy } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { formatDate } from "@angular/common";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ReportGridService } from "../services/report-grid.service";

@Component({
  selector: "app-noshow-patient",
  templateUrl: "./noshow-patient.component.html",
})
export class NoshowPatientComponent implements OnInit, OnDestroy {
  rowsData: any[] = [];
  columnsData: any = [];
  row: any = {};
  destroyComponent: any = {};
  totalItems = 0;
  maxSize = 10;
  maxSizeItem = 10;
  pageOrder: any = {};
  currentPage = 1;
  page: number;
  errorMessage = "";
  newdate: any;
  noshowdata = {
    totalnoshowCount: 0,
    todayCount: 0,
    thisWeekCount: 0,
    thisMonthCount: 0,
    thisYearCount: 0,
    tcCount: 0,
    schedCount: 0,
  };
  searchPatient = "";
  constructor(
    private api: AppService,
    private supportService: SupportService,
    private router: Router,
    private datepipe: DatePipe,
    private reportGrid: ReportGridService
  ) {}
  userType: any;
  startDate: any;
  fromMessageCentre: any;
  selectedtab: any;
  date: Date;
  newDate: Date;
  checklength(value) {
    return this.reportGrid.checklength(value);
  }

  ngOnInit() {
    this.newDate = new Date();
    let date = new Date();
    this.fromMessageCentre = sessionStorage.getItem("fromMessagecentre");
    if (this.fromMessageCentre === "true") {
      this.supportService.headerSubLittle.next("Home");
    }
    this.userType = sessionStorage.getItem("usertype");
    if (sessionStorage.getItem("currentTab") !== null) {
      this.selectedtab = sessionStorage.getItem("currentTab");
    }

    if (this.selectedtab === "today") {
      this.startDate = this.reportGrid.formatYmd(this, date);
    }
    if (this.selectedtab === "tomorrow") {
      date = new Date();
      date.setDate(date.getDate() + 1);
      this.startDate = this.reportGrid.formatYmd(this, date);
    }
    if (this.selectedtab === "yesterday") {
      date.setDate(date.getDate() - 1);
      this.startDate = this.reportGrid.formatYmd(this, date);
    }
    if (this.selectedtab === "dayafter") {
      date.setDate(date.getDate() + 2);
      this.startDate = this.reportGrid.formatYmd(this, date);
    }
    this.getRowsData();
    this.generate();
    this.getColumnOrder();

    this.newdate =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      "00:00:00";
    if (this.fromMessageCentre !== "true") {
      this.getnoshowcount();
    }
  }

  navigateToMessagecenter() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "message-center",
    ]);
  }

  private pushNoshowColumns(entity) {
    entity.forEach((obj) => {
      if (obj && obj["noshow"]) {
        const param = this.getParamData(obj);
        this.columnsData.push(param);
      }
    });
  }

  noshowPrintList: any;
  getNoshowPrintList() {
    const pageOrder = this.clearCacheItem("savePdf");
    const param = pageOrder;
    param["offsetmin"] = new Date().getTimezoneOffset();
    this.api.getScheduleByType(param).subscribe((res: any) => {
      this.noshowPrintList = [];
      if (res && res.entity) {
        this.noshowPrintList = res.entity;
      }
    });
  }

  private getRowsData() {
    this.rowsData = [
      {
        title: "First Name",
        sorting: true,
        name: "patientFirstName",
        dateFitler: false,
      },
      {
        title: "Last Name",
        sorting: true,
        name: "patientLastName",
        dateFitler: false,
      },
      {
        title: "Date Booked",
        sorting: true,
        name: "createdOn",
        dateFitler: true,
      },
      {
        title: "Date of Service",
        sorting: true,
        name: "scheduledOnStr",
        dateFitler: true,
      },
      {
        title: "Patient Type",
        sorting: true,
        name: "patientType",
        dateFitler: false,
      },
      {
        title: "Time Recorded No Show",
        sorting: true,
        name: "noshowOn",
        dateFitler: false,
      },
      { title: "By whom", sorting: false, name: "noshowBy", dateFitler: false },
      {
        title: "Reason",
        sorting: false,
        name: "noshowReason",
        dateFitler: false,
      },
    ];
    this.row = {
      param1: "patientFirstName",
      param2: "patientLastName",
      param3: "createdOn",
      param4: "scheduledOnStr",
      param5: "patientType",
      param6: "noshowOn",
      param7: "noshowBy",
      param8: "noshowReason",
    };
    this.pageOrder = {
      type: "noshow",
      pageNumber: 1,
      pageRecord: this.maxSizeItem,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "noshowOn",
      sortType: "desc",
      search: "",
    };
  }
  private getColumnData(param?, blur?) {
    if (sessionStorage.getItem("fromMessagecentre") === "true") {
      const data = {
        pageNumber: this.currentPage,
        pageRecord: this.maxSizeItem,
        search: this.searchPatient,
        fromDate: this.startDate,
        toDate: this.startDate,
        type: "patientnoshow",
        sortColumn: this.pageOrder["sortColumn"],
        sortType: this.pageOrder["sortType"],
      };

      this.api.getgriddata(data).subscribe(
        (res: any) => {
          this.columnsData = [];
          this.columnsData = [];
          if (blur && blur === "blur") {
            this.currentPage = 1;
          }
          if (res && res.entity) {
            this.totalItems = res["count"];
            this.pushNoshowColumns(res.entity);
          }
        },
        (err) => {
          if (err.error.error === "invalid_token") {
            this.api.sessionOut(err);
          }
        }
      );
    } else {
      this.api.getScheduleByType(param).subscribe(
        (res: any) => {
          this.columnsData = [];
          if (blur && blur === "blur") {
            this.currentPage = 1;
          }
          if (res && res.entity) {
            this.totalItems = res["count"];
            this.pushNoshowColumns(res.entity);
            this.getNoshowPrintList();
          }
        },
        (err) => {
          if (err.error.error === "invalid_token") {
            this.api.sessionOut(err);
          }
        }
      );
    }
  }
  private getParamData(obj) {
    const param: any = this.reportGrid.buildRowParams(this, obj);

    if (param.param3) {
      param.param3 = this.convertutctolocal(param.param3, "");
    }

    if (param.param6) {
      param.param6 = this.convertutctolocal(param.param6, "time");
    }
    return param;
  }
  private getColumnOrder() {
    this.reportGrid.getColumnOrder(this);
  }

  convertutctolocal(value, type) {
    return this.reportGrid.convertutctolocal(this.datepipe, value, type);
  }

  ngOnDestroy() {
    this.reportGrid.ngOnDestroy(this);
  }
  pageChanged(event) {
    this.reportGrid.pageChanged(this, event);
  }
  generate() {
    this.reportGrid.generate(this);
  }
  savePdf(ev) {
    this.reportGrid.savePdfWithSaveAs(this, ev);
  }
  private clearCacheItem(pdf?) {
    return {
      type: "noshow",
      pageNumber: 0,
      pageRecord: 0,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "noshowOn",
      sortType: "desc",
      search: this.pageOrder["search"] ? this.pageOrder["search"] : "",
    };
  }
  blurOnChange(ev) {
    this.reportGrid.blurOnChange(this, ev);
    this.getNoshowPrintList();
  }

  getnoshowcount() {
    const data = {
      tcId: localStorage.getItem("testCenterId"),
      date: this.newdate,
    };
    this.api.getnoshowCount(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.noshowdata = res["entity"];
            this.noshowdata.totalnoshowCount =
              res["entity"].schedCount + res["entity"].tcCount;
          } else {
            this.noshowdata = {
              totalnoshowCount: 0,
              todayCount: 0,
              thisWeekCount: 0,
              thisMonthCount: 0,
              thisYearCount: 0,
              tcCount: 0,
              schedCount: 0,
            };
          }
        }
      },
      (err) => {
        this.api.sessionOut(err);
      }
    );
  }
}
